module.exports = __webpack_public_path__ + "img/xp_line.9fb2495f.png";